import { render, staticRenderFns } from "./RecentSongList.vue?vue&type=template&id=74e6ea46&scoped=true&"
import script from "./RecentSongList.vue?vue&type=script&lang=js&"
export * from "./RecentSongList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e6ea46",
  null
  
)

export default component.exports